import { AmenityType } from 'models/Amenity';
import { RuleType } from 'models/Rule';

export const ALL_CATEGORIZED_AMENITIES_ITEMS = [
  ...Object.values(AmenityType),
  ...Object.values(RuleType),
];
